export function isDashboardAppearance(pathname = '') {
  return /^\/(?:admindashboard|masterdashboard|clientdashboard|studentdashboard|partnerdashboard|userdashboard)(?:\/|$)/.test(pathname)
    || (pathname === '/pos' || (pathname.startsWith('/pos/') && !/^\/pos\/login(?:\/|$)/.test(pathname)));
}
